import { createAction, props } from '@ngrx/store';
import { contractmanagement_api } from '@gridscale/gs-services/contractmanagement_api'; import { GSError } from '@gridscale/gsclient-js';

export const actionPrefix = '[prices]';

export const loadPrices = createAction(actionPrefix + ' Load Prices');
export const loadPricesSuccess = createAction(actionPrefix + ' Load Prices Success', props<{
  links: contractmanagement_api.PaginatedPricelistPricesResponseLinks;
  data: Array<contractmanagement_api.PriceListLocationDataListItem>;
  meta: { [key: string]: any; };
}>());
export const loadPricesFailure = createAction(actionPrefix + ' Load Prices Failure', props<{ error: GSError }>());
